import { put, select, takeLatest } from 'redux-saga/effects';
import { getOrderList } from '../Services/InventoryService';
import { tableAction, tableActions, tableInitialState } from '../../App/Ducks/Table.duck';

export const actionTypes = {
  RequestData: '[Order] RequestOrder',
  FulfilledTable: '[Order] FulfilledOrder',
  SearchTable: '[Order] Search Order',
  ChangePage: '[Order] change page',
  SetPageSize: '[Order] set page size',
  SortTable: '[Order] Sort Order',
  ApplyFilter: '[Order] Apply filter',
  RemoveFilter: '[Order] Remove filter',
  ResetFilters: '[Order] Reset filter',
};

const initialState = {
  ...tableInitialState,
  sortBy: { name: 'asc' },
};

export const reducer = (state = initialState, action) => {
  const newState = tableAction(actionTypes, state, action);

  switch (action.type) {
    default:
      return newState;
  }
};

export const actions = {
  ...tableActions(actionTypes),
};

export function* saga() {
  function* reloadData() {
    yield put(actions.requestData());
  }

  yield takeLatest(actionTypes.SearchTable, reloadData);
  yield takeLatest(actionTypes.ChangePage, reloadData);
  yield takeLatest(actionTypes.SetPageSize, reloadData);
  yield takeLatest(actionTypes.SortTable, reloadData);
  yield takeLatest(actionTypes.ApplyFilter, reloadData);
  yield takeLatest(actionTypes.RemoveFilter, reloadData);
  yield takeLatest(actionTypes.ResetFilters, reloadData);

  yield takeLatest(actionTypes.RequestData, function* requestOrderSaga() {
    const currentTenantId = yield select(state => state.AppReducer.tenant.tenantId);
    const currentState = yield select(state => state.OrderListReducer);
    const itemId = yield select(state => state.InventoryItemReducer.item.inventoryItemId);

    const response = yield getOrderList(
      currentTenantId,
      itemId,
      currentState.page,
      currentState.pageSize,
      currentState.sortBy,
      currentState.filters,
      currentState.searchQuery,
    );

    yield put(actions.fulfilled(response.items, response.total));
  });
}
